import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "item-sku-attrs-header" }
const _hoisted_2 = { key: 0 }

import { OioInput } from '@kunlun/vue-ui-antd';
import { DeleteOutlined } from '@ant-design/icons-vue';
import { useAddItemSku } from '@/custom-widget/MindMap/hooks';
import { PropType } from 'vue';
import { ViewType } from '@kunlun/dependencies';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemSkuAttrsHeader',
  props: {
  dataSource: {
    type: Array,
    default: () => []
  },
  itemName: {
    type: String,
    default: ''
  },
  viewType: {
    type: String as PropType<ViewType>
  }
},
  setup(__props) {

const props = __props



const { itemSkuHeaderList } = useAddItemSku();
const handleChange = (index: number, value: string) => {
  itemSkuHeaderList.value[index].attrName = value;
  if (props.dataSource.length) {
    props.dataSource.forEach((item: any) => {
      item[props.itemName][index].attrName = value;
    });
  }
};

const handleDelete = (index: number) => {
  itemSkuHeaderList.value.splice(index, 1);

  if (props.dataSource.length) {
    props.dataSource.forEach((item: any) => {
      item[props.itemName].splice(index, 1);
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemSkuHeaderList), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item-sku-attrs-header-sub", __props.viewType === _unref(ViewType).Detail ? 'item-sku-attrs-header-sub-detail' : '']),
        key: index
      }, [
        (__props.viewType === _unref(ViewType).Detail)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.attrName), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(OioInput), {
                placeholder: "规格名称",
                value: item.attrName,
                "onUpdate:value": ($event: any) => (handleChange(index, $event))
              }, null, 8, ["value", "onUpdate:value"]),
              (item.showDelIcon)
                ? (_openBlock(), _createBlock(_unref(DeleteOutlined), {
                    key: 0,
                    onClick: ($event: any) => (handleDelete(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 64))
      ], 2))
    }), 128))
  ]))
}
}

})